const codemirrorRegistry = new Map<string, any>();

export const registerEditor = (id: string, editor: any) => {
  codemirrorRegistry.set(id, editor);
};

export const getEditor = (id: string) => codemirrorRegistry.get(id);

export const unregisterEditor = (id: string) => {
  codemirrorRegistry.delete(id);
};
